import React, { useState } from "react";

import MentionAutocomplete from "./MentionAutocomplete";

export default function ContentQuestionAnswerForm({ moduleId, onSubmit, submitting }) {
    const [message, setMessage] = useState("");
    const [files, setFiles] = useState([]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        await onSubmit?.({ message, files });
        setMessage("");
        setFiles([]);
        form.reset();
    };

    return (
        <form className="cq-form" onSubmit={handleSubmit}>
            <MentionAutocomplete
                moduleId={moduleId}
                value={message}
                onChange={setMessage}
                placeholder="Votre reponse"
                required
            />
            <label className="cq-file-field">
                <span>Pieces jointes</span>
                <input
                    type="file"
                    multiple
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt,.xlsx"
                    onChange={(event) => setFiles(Array.from(event.target.files || []))}
                />
            </label>
            {files.length > 0 ? (
                <div className="cq-file-preview">
                    {files.map((file) => (
                        <span key={`${file.name}-${file.size}`}>{file.name}</span>
                    ))}
                </div>
            ) : null}
            <div className="cq-answer-actions">
                <button type="submit" className="cq-btn cq-btn--primary" disabled={submitting}>
                    Répondre
                </button>
            </div>
        </form>
    );
}
